import React, { useState } from 'react'
import { Icon } from '@scentregroup/ui'
import style from './index.module.scss'

type Props = {
  onSubmit: (event: React.FormEvent<unknown>, query: string) => void
  onClickClose: () => void
}

function SearchModal(props: Props): JSX.Element {
  const { onSubmit, onClickClose } = props

  const [query, setQuery] = useState('')

  const handleKeyPress: React.KeyboardEventHandler<HTMLInputElement> = e => {
    if (e.key === 'Enter') {
      // Trigger blur event to dismiss the Keyboard when user clicks Search in iOS.
      if (!window.document.activeElement) {
        return
      }

      ;(window.document.activeElement as HTMLInputElement).blur()
    }
  }

  function onSubmitWrapper(e: React.FormEvent<unknown>): void {
    onSubmit(e, query)
  }

  return (
    <div className={style.searchModalInputSection}>
      <button
        aria-label="Close search"
        className={style.closeButton}
        onClick={onClickClose}
      >
        <Icon type="cross" />
      </button>
      <div className={style.inputbar} onSubmit={onSubmitWrapper}>
        <form action="#" onSubmit={e => e.preventDefault()}>
          <input
            /* Disabling no-autofocus to convert legacy JS file to TypeScript */
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            id="search-textfield"
            type="search"
            className={style.textfield}
            autoCapitalize="off"
            spellCheck="false"
            autoCorrect="off"
            autoComplete="off"
            placeholder="Search stores, brands, products and more"
            value={query}
            onChange={event => setQuery(event.target.value)}
            onKeyPress={handleKeyPress}
          />
          <label htmlFor="search-textfield">
            <Icon type="search" className={style.searchIcon} />
          </label>
          {query ? (
            <button
              aria-label="Clear search text"
              className={style.clearButton}
              type="button"
              onClick={() => setQuery('')}
            >
              <Icon type="clear" size="small" className={style.clearIcon} />
            </button>
          ) : null}
          <button className={style.searchButton} aria-label="search button">
            SEARCH
          </button>
        </form>
      </div>
    </div>
  )
}

export default SearchModal
